// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__3ZclR","title":"ClientCherryInfo_title__3K2fR","itemText":"ClientCherryInfo_itemText__wicNE"};